import { API, graphqlOperation } from "aws-amplify";

import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import { BranchUpdateForm as ABranchUpdateForm } from "ui-components/index";
import { getBranch } from "graphql/queries";

const BranchUpdateForm = ({ branchId, onSuccess }) => {
  const navigate = useNavigate();
  const { companyId } = useParams();
  const [branch, setBranch] = useState();

  const onSuccessForm = () => {
    toast.success(strings.successUpdated);
    if (onSuccess) onSuccess();
    else navigate(`/companies/${companyId}/details`);
  };
  const onError = (_model, error) => toast.error(strings.responses[error]);

  async function fetchBranch(id) {
    try {
      const branchData = await API.graphql(graphqlOperation(getBranch, { id }));
      const branchItem = branchData.data.getBranch;
      if (!branchItem) {
        toast.error(strings.responses.errorFetch);
        navigate(`/companies/${companyId}/details`);
        return;
      }
      setBranch(branchItem);
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchBranch(branchId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId]);

  return (
    <div>
      <ABranchUpdateForm
        branch={branch}
        overrides={{
          name: {
            label: (
              <span>
                {strings.fields.name}
                <span style={{ fontSize: "0.8rem", color: "red" }}>{" *"}</span>
              </span>
            ),
          },
          customId: {
            label: (
              <span>
                {strings.fields.id}
                <span style={{ fontSize: "0.8rem", color: "red" }}>{" *"}</span>
              </span>
            ),
          },
          abbreviation: {
            label: strings.fields.abbreviation,
          },
          address: {
            label: strings.fields.address,
          },
          phone: {
            label: strings.fields.phone,
          },
          country: {
            label: strings.fields.country,
          },
          city: {
            label: strings.fields.city,
          },
          description: {
            label: strings.fields.description,
          },
          ResetButton: {
            children: strings.reset,
          },
          SubmitButton: {
            children: strings.update,
          },
        }}
        onSuccess={onSuccessForm}
        onError={onError}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Sede",
    reset: "Restablecer",
    update: "Actualizar",
    successUpdated: "Sede actualizada con éxito",
    responses: {
      errorFetch: "Error al consultar la sede",
    },
    fields: {
      id: "Identificador",
      name: "Nombre Sede",
      abbreviation: "Abreviatura",
      address: "Dirección",
      phone: "Teléfono",
      country: "País",
      city: "Ciudad",
      description: "Descripción",
    },
  },
});

export default BranchUpdateForm;
